import { mapGetters, mapActions } from 'vuex'
import { getMasterDataText } from '@/helpers'

export default {
  data () {
    return {
      isRenderTime: true,
      timer: null,
      tableCount: 0,
      moveFromTableNumber: null,
      moveToTableNumber: null,
    }
  },
  computed: {
    ...mapGetters({
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // current selected table number
      dining_name: 'getPosSelectedDiningName',
      customer_id: 'getPosSelectedCustomerId',
      tableInfo: 'getPosTableById', // table info
      tables: 'getPosTables',
      orders: 'getPosOrders', // orders
      posSettings: 'getPosSetting',
      getPosOrdersById: 'getPosOrdersById',
      getCustomerById: 'getCustomerById',
      queues: 'getPosQueues',
    }),
    takenTabls () {
      var arr = []
      for (let i in this.orders) {
        let item = this.orders[i]
        if (arr.indexOf(item.table_number) === -1) {
          arr.push(item.table_number)
        }
      }
      return arr
    },
    availableTablesCount () {
      return this.tableLists.length - this.tables.length
    },
    hasDisabledTable() {
      return this.mapTables.some((item) => item.disabled)
    },
    tableLists() {
      return this.posSettings.table.lists.filter((item) => item.is_active)
    },
    mapTables() {
      let result = []
      for (const item of this.tableLists) {
        const tableInfo = this.tableInfo(item.name)
        const disabled = this.isDisabled(item.name)
        let queue_number = null
        if (this.use_queue) {
          const queue = this.queues.find((queueItem) => queueItem.table_number == item.name)
          if (queue) {
            queue_number = queue.queue_number
          }
        }
        result.push({
          ...tableInfo,
          table_number: item.name,
          queue_number: queue_number,
          classNames: [
            this.classObject(item.name),
            { active: item.name == this.table_number ? 'active' : '' },
            { 'disabled': disabled },
          ],
          orderCount: this.getOrdersByTableNumber(item.name).reduce((acc, cur) => {
            const order = cur
            acc += order.quantity
            return acc
          }, 0),
          diningName: tableInfo ? this.getDiningText(tableInfo.dining_name) : null,
          customerName: tableInfo ? this.getCustomerName(tableInfo.customer_id) : null,
          disabled: disabled,
        })
      }
      return result
    },
    use_queue () {
      return this.posSettings.queue.is_active
    },
    use_table () {
      return this.posSettings.table.is_active
    },
    use_dining () {
      return this.posSettings.dining.is_active
    },
    refName () {
      return getMasterDataText(this.posSettings.table.ref_name, this.$t)
    },
    moveOrders() {
      if (this.use_queue) {
        if (this.table_number != null && this.moveFromTableNumber != null) {
          return this.getOrdersByTableNumber(this.moveFromTableNumber)
        } else if (this.table_number == null) {
          return this.getOrdersByQueueAndTableNumber(this.queue_number, null)
        }
      } else if (this.use_table) {
        if (this.table_number != null && this.moveFromTableNumber != null) {
          return this.getOrdersByTableNumber(this.moveFromTableNumber)
        } else if (this.table_number == null) {
          return this.getOrdersByTableNumber(null)
        }
        return []
      }
    },
    moveOrderModalTitle() {
      return this.$t('apps.pos.message.movemodaltitle', { ref_name: this.refName })
    },
    moveFromTableOptions() {
      return this.tableLists.reduce((acc, cur) => {
        this.tables.forEach((table) => {
          if (cur.name == table.table_number) {
            acc.push({
              text: `${this.refName} ${table.table_number}`,
              value: table.table_number,
            })
          }
        })
        return acc
      }, [])
    },
    moveToTableOptions() {
      const fromTableNumbers = this.moveFromTableOptions.map((table) => table.value)
      return this.mapTables.filter((table) => {
        return !fromTableNumbers.includes(table.table_number)
      }).map((table) => {
        return {
          text: `${this.refName} ${table.table_number}`,
          value: table.table_number,
        }
      })
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
      'setPosSelectedTable',
      'clearPosSelectedTable',
      'setPosSelectedCustomerId',
      'setCustomIdForQueueAndTable',
      'setPosSelectedDiningName',
      'setDiningNameForQueueAndTable',
      'movePosOrderToTable',
      'setPosSelectedQueue',
    ]),
    onSelectedTable (table_number) {
      this.setPosSelectedTable(table_number)

      // eslint-disable-next-line no-unneeded-ternary
      const table = this.tables.find((tableItem) => tableItem.table_number == table_number)
      let isThisTableSelectedDiningName = !!((table && table.dining_name))
      if (this.use_dining && !isThisTableSelectedDiningName) {
        const defaultDining = this.posSettings.dining.options.find((item) => item.is_default).name
        this.setPosSelectedDiningName({
          name: defaultDining,
        })
        this.setDiningNameForQueueAndTable()
      }

      this.setPosSection('choose-product')
    },
    onStandBy () {
      this.clearPosSelectedTable()
      this.setPosSection('choose-product')
    },
    isTaken (table_number) {
      return this.takenTabls.indexOf(table_number) >= 0
    },
    classObject (table_number) {
      return !this.isTaken(table_number) ? 'available' : null
    },
    getOrdersByTableNumber(table_number) {
      return this.orders.filter((order) => order.table_number == table_number)
    },
    getOrdersByQueueAndTableNumber(queue_number, table_number) {
      return this.orders.filter((order) => order.queue_number == queue_number && order.table_number == table_number)
    },
    isDisabled(table_number) {
      const useQueue = this.use_queue
      const useTable = this.use_table
      if (useQueue) {
        const selectedTableNumbers = this.queues.reduce((acc, cur) => {
          if (cur.table_number != null) {
            acc.push(cur.table_number)
          }
          return acc
        }, [])
        const selectedQueue = this.queues.find((queueItem) => queueItem.queue_number == this.queue_number)
        if (selectedQueue.table_number != null) {
          const selectedQueueOrders = this.orders.filter((orderItem) => orderItem.table_number == this.table_number)
          if (table_number == selectedQueue.table_number) {
            return false
          }
          const currentTableOrders = this.orders.filter((orderItem) => orderItem.table_number == table_number)
          return selectedTableNumbers.includes(table_number) || currentTableOrders.length || selectedQueueOrders.length
        } else {
          if (this.table_number == null) {
            const selectedQueueOrders = this.getOrdersByQueueAndTableNumber(this.queue_number, null)
            return selectedQueueOrders.length
          } else {
            const selectedQueueOrders = this.getOrdersByTableNumber(table_number)
            return selectedQueueOrders.length
          }
        }
      } else if (useTable) {
        const notSelectedTableOrders = this.getOrdersByTableNumber(null)
        return this.table_number == null && notSelectedTableOrders.length > 0
      } else {
        return false
      }
    },
    getDiningText(diningName) {
      return getMasterDataText(diningName, this.$t)
    },
    getCustomerName (customerId) {
      const customer = this.getCustomerById(customerId)
      return customer ? customer.customer_name : null
    },
    handleClickMoveTable() {
      this.moveFromTableNumber = null
      this.moveToTableNumber = null
      this.$bvModal.show('modal-confirm-move-table')
    },
    handleCloseMoveTable(ok) {
      ok()
    },
    handleConfirmMoveTable(ok) {
      const fromTable = this.moveFromTableNumber
      const toTable = this.moveToTableNumber
      const tableInfo = this.tableInfo(fromTable)
      let currentDiningName
      let currentCustomerId
      if (tableInfo) {
        currentDiningName = tableInfo.dining_name
        currentCustomerId = tableInfo.customer_id
      } else {
        currentDiningName = this.dining_name
        currentCustomerId = this.customer_id
      }

      /**
       * move all things to new table "orders, dining_name, customer_id"
       */

      if (this.use_queue) {
        if (fromTable == null) {
          const queueInfo = this.queues.find((queueItem) => queueItem.queue_number == this.queue_number)
          this.setPosSelectedQueue(queueInfo.queue_number)
          this.setPosSelectedTable(toTable)
          this.movePosOrderToTable({ fromTable: fromTable, toTable: toTable, queueNumber: queueInfo.queue_number })
        } else {
          const queueInfo = this.queues.find((queueItem) => queueItem.table_number == fromTable)
          this.setPosSelectedQueue(queueInfo.queue_number)
          this.setPosSelectedTable(toTable)
          this.movePosOrderToTable({ fromTable: fromTable, toTable: toTable, queueNumber: queueInfo.queue_number })
        }
      } else {
        this.setPosSelectedTable(toTable)
        this.movePosOrderToTable({ fromTable: fromTable, toTable: toTable })
      }

      this.setPosSelectedDiningName({ name: currentDiningName })
      this.setDiningNameForQueueAndTable()

      this.setPosSelectedCustomerId({ customer_id: currentCustomerId, customer_new: false })
      this.setCustomIdForQueueAndTable()

      // reset data
      this.isClickedMoveTable = false
      this.moveFromTableNumber = null
      this.moveToTableNumber = null

      // back to
      ok()
      this.setPosSection('choose-product')
    },
  },
  watch: {

  },
  mounted: function () {
    const that = this
    this.timer = setInterval(function() {
      that.isRenderTime = false
      that.$nextTick(function() {
        that.isRenderTime = true
      })
    }, 1000)
  },
  destroyed() {
    clearInterval(this.timer)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/tableList.js